import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { City } from 'src/app/interfaces/api/city';
import { Product, Wishlist } from 'src/app/interfaces/api/product';
import { encodeQueryParam, transformWeight } from 'src/helpers';

@Component({
  selector: 'app-wishlist-product-card',
  templateUrl: './wishlist-product-card.component.html',
  styleUrls: ['./wishlist-product-card.component.scss'],
})
export class WishlistProductCardComponent implements OnInit {
  @Input() wishlist: Wishlist;
  @Input() isLoading: boolean;

  weight: string;
  selectedCity: City;

  constructor(private router: Router) {}

  async ngOnInit() {
    this.selectedCity = JSON.parse((await Preferences.get({ key: 'selectedCity' })).value);
    this.weight = transformWeight(this.wishlist?.mh_product?.weight);
  }

  goToProductDetailPage() {
    this.router.navigate(['product-detail', this.wishlist?.mh_product?.id], {
      queryParams: {
        selectedWarehouseId: encodeQueryParam(this.wishlist?.mh_product?.id_mh_warehouse),
      },
    });
  }
}
